"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("./constants");

var _Popover = _interopRequireDefault(require("../Popover"));

require("./TooltipBase.css");

require("./Tooltip.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** A basic widget for getting the user input is a text field.
 * Keyboard and mouse can be used for providing or changing data. */
function Tooltip(props) {
  var title = props.title,
      theme = props.theme,
      children = props.children,
      overlayClassName = props.overlayClassName,
      rest = _objectWithoutProperties(props, ["title", "theme", "children", "overlayClassName"]);

  return title ? /*#__PURE__*/_react.default.createElement(_Popover.default, _extends({}, rest, {
    title: title,
    className: "rc-tooltiped-text",
    overlayClassName: "Tooltip ".concat(theme ? "rc-tooltip-".concat(theme) : '', " ").concat(overlayClassName)
  }), children) : children;
}

Tooltip.propTypes = {
  /** The text shown in the tooltip */
  title: _propTypes.default.string,

  /** Can be set to 'dark' or omitted (meaning default) */
  theme: _propTypes.default.oneOf(_constants.TOOLTIP_THEMES),

  /** @ignored */
  overlayClassName: _propTypes.default.string,

  /** @ignored */
  children: _propTypes.default.node
};
Tooltip.defaultProps = {
  title: null,
  theme: null,
  overlayClassName: '',
  children: null
};
var _default = Tooltip;
exports.default = _default;